/**
 * ProjectEditDialog — 知识库选择 Tab
 * 支持切换「我的知识库」/「共享知识库」来源
 */
import React, { useState } from 'react';
import { KnowledgeBase } from '../types';

interface KnowledgeBaseSelectTabProps {
  ownedKnowledgeBases: KnowledgeBase[];
  sharedKnowledgeBases: KnowledgeBase[];
  knowledgeBaseIds: number[];
  setKnowledgeBaseIds: React.Dispatch<React.SetStateAction<number[]>>;
}

export default function KnowledgeBaseSelectTab({
  ownedKnowledgeBases, sharedKnowledgeBases, knowledgeBaseIds, setKnowledgeBaseIds,
}: KnowledgeBaseSelectTabProps) {
  const [source, setSource] = useState<'owned' | 'shared'>('owned');
  const knowledgeBases = source === 'owned' ? ownedKnowledgeBases : sharedKnowledgeBases;

  return (
    <div className="space-y-4">
      <div className="text-sm text-gray-500">
        关联知识库，生成内容时将引用所选知识库中的资料（可多选）
      </div>

      {/* 来源切换 */}
      <div className="flex gap-1">
        <button
          onClick={() => setSource('owned')}
          className={`px-3 py-1 text-xs font-medium rounded-lg transition-colors ${
            source === 'owned'
              ? 'bg-blue-100 text-blue-700'
              : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
          }`}
        >
          我的知识库
        </button>
        <button
          onClick={() => setSource('shared')}
          className={`px-3 py-1 text-xs font-medium rounded-lg transition-colors ${
            source === 'shared'
              ? 'bg-blue-100 text-blue-700'
              : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
          }`}
        >
          共享知识库
        </button>
      </div>

      {knowledgeBases.length === 0 ? (
        <p className="text-xs text-gray-400 py-2">
          {source === 'owned'
            ? '暂无可用的知识库，请在"我的设置 → 知识库"中创建'
            : '暂无共享的知识库'}
        </p>
      ) : (
        <div className="max-h-64 overflow-y-auto border border-gray-300 rounded-lg divide-y divide-gray-100">
          {knowledgeBases.map((kb) => {
            const checked = knowledgeBaseIds.includes(kb.id);
            return (
              <label key={kb.id} className="flex items-center px-3 py-2.5 cursor-pointer hover:bg-gray-50 transition-colors">
                <input type="checkbox" checked={checked}
                  onChange={() => setKnowledgeBaseIds((prev) => checked ? prev.filter((id) => id !== kb.id) : [...prev, kb.id])}
                  className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" />
                <span className="ml-2 text-sm text-gray-700 flex-1">{kb.name}</span>
                {source === 'shared' && (
                  <span className="text-xs text-purple-600 bg-purple-50 px-1.5 py-0.5 rounded">共享</span>
                )}
                <span className="text-xs text-gray-400 ml-2">{kb.file_count} 个文件</span>
              </label>
            );
          })}
        </div>
      )}
      {knowledgeBaseIds.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {knowledgeBases.filter((kb) => knowledgeBaseIds.includes(kb.id)).map((kb) => (
            <span key={kb.id} className="inline-flex items-center gap-1 px-2.5 py-1 rounded text-xs bg-purple-50 text-purple-700">
              {kb.name}
              <button type="button" onClick={() => setKnowledgeBaseIds((prev) => prev.filter((id) => id !== kb.id))}
                className="text-purple-400 hover:text-purple-600">×</button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
